<template>
  <div>
    <!-- TBM(작업 전 안전점검회의) -->
    <div>
      <h1 class="titleFull">TBM(작업 전 안전점검회의)</h1>
      <table class="table1">
        <tr>
          <td colspan="2" class="titleCell">사업장명</td>
          <td colspan="4">{{ form.stdInfo.field_name }}</td>
          <td colspan="2" class="titleCell">소속명</td>
          <td colspan="4">{{ form.stdInfo.section }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">부서(업체)명</td>
          <td colspan="4">{{ form.stdInfo.section }}</td>
          <td colspan="2" class="titleCell">직책</td>
          <td colspan="4">{{ form.stdInfo.rank }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">작성자</td>
          <td colspan="4">{{ form.stdInfo.writer_name }}</td>
          <td colspan="2" class="titleCell">작성일</td>
          <td colspan="4">{{ form.stdInfo.date }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">TBM 일시</td>
          <td colspan="10">{{ form.inputB_1 }}, {{ form.inputB_2 }}~{{ form.inputB_3 }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">작업명</td>
          <td colspan="4">{{ form.inputB_4 }}</td>
          <td colspan="2" class="titleCell">작업내용</td>
          <td colspan="4">{{ form.inputB_5 }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">TBM 장소</td>
          <td colspan="4">{{ form.inputB_6 }}</td>
          <td colspan="2" class="titleCell">위험성평가 실시여부</td>
          <td colspan="4">{{ form.inputB_7 }}</td>
        </tr>
        <tr v-for="(item, item_i) in form.risk_factors" :key="`risk_factors_${item_i}`">
          <td v-if="item_i === 0" :rowspan="form.risk_factors.length" colspan="2" class="titleCell">잠재위험요인</td>
          <td colspan="2" class="titleCell">잠재위험요인</td>
          <td colspan="3">{{ item.input1 }}</td>
          <td colspan="2" class="titleCell">대책</td>
          <td colspan="3">{{ item.input2 }}</td>
        </tr>
        <tr>
          <td rowspan="2" colspan="2" class="titleCell">중점위험요인</td>
          <td colspan="2" class="titleCell">선정</td>
          <td colspan="8">{{ form.inputD_1 }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">대책</td>
          <td colspan="8">{{ form.inputD_2 }}</td>
        </tr>
        <tr>
          <td rowspan="2" colspan="2" class="titleCell">TBM 리더 확인</td>
          <td colspan="2" class="titleCell">소속명</td>
          <td colspan="3">{{ form.inputE_1 }}</td>
          <td colspan="2" class="titleCell">직책</td>
          <td colspan="3">{{ form.inputE_2 }}</td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">성명</td>
          <td colspan="3">{{ form.inputE_3 }}</td>
          <td colspan="2" class="titleCell">서명</td>
          <td colspan="3" class="p-0"><img v-if="!!form.inputE_4" :src="form.inputE_4"  class="w-full"/></td>
        </tr>
        <fragment v-for="(item, item_i) in form.safety_measures" :key="`safety_measures_${item_i}`">
          <tr>
            <td v-if="item_i === 0" :rowspan="form.safety_measures.length * 2" colspan="2" class="titleCell">
              <span>
                작업 전 안전조치 확인<br />
                ※위 잠재위험요인<br />
                (중점위험 포함) <br />
                안전조치 여부 재확인
              </span>
            </td>
            <td colspan="2" class="titleCell">잠재위험요소(중점위험 포함)</td>
            <td colspan="3">{{ item.input1 }}</td>
            <td colspan="2" class="titleCell">조치여부</td>
            <td colspan="3">{{ item.input2 }}</td>
          </tr>
          <tr>
            <td colspan="2" class="titleCell">‘아니오’인 경우 조치 내용</td>
            <td colspan="8">{{ item.input3 }}</td>
          </tr>
        </fragment>
        <tr>
          <td colspan="2" class="titleCell">
            <span>
              작업 전 일일<br />
              안전점검 시행 결과
            </span>
          </td>
          <td colspan="10">
            <div class="print-textarea" style="margin: 0; padding: 0 !important; border: none; min-height: auto">
              {{ form.inputF_1 }}
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="titleCell">
            <span>
              작업 후 종료 미팅 <br />
              (중점대책의 실효성)
            </span>
          </td>
          <td colspan="10">
            <div class="print-textarea" style="margin: 0; padding: 0 !important; border: none; min-height: auto">
              {{ form.inputF_2 }}
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- TBM(작업 전 안전점검회의) 참석자 명단 -->
    <div class="print-container">
      <h1 class="titleFull">TBM(작업 전 안전점검회의) 참석자 명단</h1>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-6 flex items-start">
          <div class="label-text mr-4 mt-2">교육구분</div>
          <span class="print-input"> {{ !!form.inputB_4 ? form.inputB_4 : "" }} </span>
        </div>
        <div class="col-span-6 flex items-start">
          <div class="label-text mr-4 mt-2">TBM 일시</div>
          <span class="print-input"> {{ form.inputB_1 }}, {{ form.inputB_2 }} ~ {{ form.inputB_3 }} </span>
        </div>
      </div>

      <table style="margin-top: 24px" class="pageBreak">
        <tr>
          <td style="width: 50%; padding-right: 5px">
            <table class="attendeeTable">
              <tbody>
                <tr>
                  <td class="titleCell">No.</td>
                  <td class="titleCell">소속</td>
                  <td class="titleCell">직종</td>
                  <td class="titleCell">성명</td>
                  <td class="titleCell">서명</td>
                  <td class="titleCell">비고</td>
                </tr>
                <tr v-for="index in 20" :key="index">
                  <td>{{ index }}</td>
                  <td>{{ !!form.participant[index - 1] ? form.participant[index - 1].target : "" }}</td>
                  <td>{{ !!form.participant[index - 1] ? form.participant[index - 1].class : "" }}</td>
                  <td>{{ !!form.participant[index - 1] ? form.participant[index - 1].name : "" }}</td>
                  <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                    <img v-if="!!form.participant[index - 1]" height="50" :src="form.participant[index - 1].sign" />
                  </td>
                  <td>{{ !!form.participant[index - 1] ? form.participant[index - 1].note : "" }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <!--<td style="width: 10px;"></td>-->
          <td style="width: 50%; padding-left: 5px">
            <table class="attendeeTable">
              <tbody>
                <tr>
                  <td class="titleCell">No.</td>
                  <td class="titleCell">소속</td>
                  <td class="titleCell">직종</td>
                  <td class="titleCell">성명</td>
                  <td class="titleCell">서명</td>
                  <td class="titleCell">비고</td>
                </tr>
                <tr v-for="index in 20" :key="index + 20">
                  <td>{{ index + 20 }}</td>
                  <td>{{ !!form.participant[index + 20 - 1] ? form.participant[index + 20 - 1].target : "" }}</td>
                  <td>{{ !!form.participant[index + 20 - 1] ? form.participant[index + 20 - 1].class : "" }}</td>
                  <td>{{ !!form.participant[index + 20 - 1] ? form.participant[index + 20 - 1].name : "" }}</td>
                  <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                    <img v-if="!!form.participant[index + 20 - 1]" height="50" :src="form.participant[index + 20 - 1].sign" />
                  </td>
                  <td>{{ !!form.participant[index + 20 - 1] ? form.participant[index + 20 - 1].note : "" }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </div>

    <!-- 사진대지 -->
    <h1 v-if="false" class="titleFull">안전교육 사진대지</h1>
    <div v-for="photo in form.photoList" :key="photo.id" v-show="photo.path" class="mb-6 photoWrap">
      <div class="photoContainer">
        <img height="600" :src="photo.path" :alt="photo.input" />
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-2">
        <div class="col-span-12 flex items-start">
          <span class="print-input"> {{ photo.input }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print377",
  props: {
    form: Object,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
$approval-border: 2px solid #cdcdcd;
$title-bg-color: #f9f9f9;
.titleCell {
  background-color: $title-bg-color;
  text-align: center;
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    border-bottom: 0;
  }
}
.contentTable {
  td {
    border: 1px solid $border-color;
    padding: 19px 14px;
  }
  .titleCell {
    width: 180px;
    padding: 19px 0;
    font-size: 14px;
    font-weight: 500;
  }
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.attendeeTable {
  td {
    height: 60px;
    border: 1px solid $border-color;
    text-align: center;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
  }
}
.photoWrap:nth-child(2n) {
  page-break-after: always;
}
img {
  -webkit-print-color-adjust: exact;
}
.pageBreak {
  page-break-after: always;
}

.table1 {
  table-layout: fixed;
  border-collapse: collapse;
  &,
  td {
    border: 1px solid $border-color;
    padding: 20px 0;
    text-align: center;
  }

  .titleCell {
    font-size: 14px;
    font-weight: 500;

    & > span {
      display: inline-block;
      text-align: left;
      margin: auto;
    }
  }
}
</style>
